var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 19.3333H17.6667M9.33337 26H24.3334M29.3334 11C30.6595 11 31.9312 10.4732 32.8689 9.53553C33.8066 8.59785 34.3334 7.32608 34.3334 6C34.3334 4.67392 33.8066 3.40215 32.8689 2.46447C31.9312 1.52678 30.6595 1 29.3334 1C28.0073 1 26.7355 1.52678 25.7978 2.46447C24.8602 3.40215 24.3334 4.67392 24.3334 6C24.3334 7.32608 24.8602 8.59785 25.7978 9.53553C26.7355 10.4732 28.0073 11 29.3334 11Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1H12.6667C4.33333 1 1 4.33333 1 12.6667V22.6667C1 31 4.33333 34.3333 12.6667 34.3333H22.6667C31 34.3333 34.3333 31 34.3333 22.6667V14.3333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.c603ed730fe95b83b538f398701d421c.svg";
export { ForwardRef as ReactComponent };